import Reveal from './Reveal';
import { CAPABILITIES } from '../lib/site';

const CapabilityCard = ({ cap, index }) => (
  <Reveal
    delay={index * 0.1}
    className="group bg-[#050B14] p-8 lg:p-10 relative hover:bg-[#0A1628] transition-colors duration-500"
    data-testid={`capability-card-${index}`}
  >
    <span className="font-display text-[4rem] font-semibold leading-none text-white/5 group-hover:text-[#00E5FF]/10 transition-colors duration-500 block -mb-3">
      {cap.number}
    </span>

    <div className="h-px w-8 bg-[#00E5FF]/50 group-hover:w-12 group-hover:bg-[#00E5FF] transition-all duration-500 mb-6" />

    <h3 className="font-display font-semibold text-white text-xl leading-tight mb-4">
      {cap.title}
    </h3>
    <p className="font-body text-sm text-[#94A3B8] leading-relaxed font-light">
      {cap.body}
    </p>

    <div className="absolute bottom-0 left-0 h-px w-0 bg-[#00E5FF] group-hover:w-full transition-all duration-500" />
  </Reveal>
);

export default function Capabilities() {
  return (
    <section id="capabilities" className="bg-[#050B14] py-28 lg:py-36 relative overflow-hidden" data-testid="capabilities-section">
      <div className="absolute inset-0 dot-grid opacity-15 [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="mb-20 max-w-2xl">
          <span className="font-body text-[11px] font-semibold uppercase tracking-[0.25em] text-[#00E5FF]">
            How We Operate
          </span>
          <span className="line-electric mt-3 mb-6 block" />
          <h2
            className="font-display font-semibold text-white leading-[1.1]"
            style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
          >
            Four capabilities. Seamless execution.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {CAPABILITIES.map((cap, i) => (
            <CapabilityCard key={cap.number} cap={cap} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
